<app-organizer-shared-form-wrapper
  class="organizer-activity-creation-page-url"
  [activeStep]="2"
  [error$]="error$"
  [loading$]="loading$"
  [formGroup]="formGroup"
  [sectionDescription]="'activity_creation.url.section.description' | translate"
  [sectionTitle]="'activity_creation.url.section.title' | translate"
  [tipsConfig]="tipsConfig"
  (formSubmit)="submit($event)"
>
  <app-form-control [errorMessages]="errorMessages('url')">
    <app-form-input
      formControlName="url"
      [placeholder]="'activity_creation.url.form.url.placeholder' | translate"
      [hasError]="
        formGroup.get('url')?.invalid && formGroup.get('url')?.touched
      "
    ></app-form-input>
  </app-form-control>
  <app-form-control
    *appIsEnabled="toggleNameEnum.OrganizerActivityHasUrlPassword"
    [label]="'activity_creation.url.note_for_attendees.label' | translate"
  >
    <app-form-input
      formControlName="noteForAttendees"
      [placeholder]="
        'activity_creation.url.note_for_attendees.placeholder' | translate
      "
    ></app-form-input>
  </app-form-control>
</app-organizer-shared-form-wrapper>

<app-alert-modal
  [closeLabel]="'activity_creation.url.modal.close' | translate"
  [confirmLabel]="'activity_creation.url.modal.confirm' | translate"
  (modalConfirm)="superSubmit(formGroup.value)"
  (modalClose)="closeModal()"
>
  <h2 modal-header>{{ 'activity_creation.url.modal.header' | translate }}</h2>
  <p modal-content>
    {{ 'activity_creation.url.modal.description' | translate }}
  </p>
</app-alert-modal>
